import React from 'react';
import c from 'classnames';

import { SearchAllContentHit } from '../../SearchAllContent/types';

import './style.scss';

export interface SearchAutocompleteResultProps {
  hit: SearchAllContentHit;
}

const SearchAutocompleteResult: React.FC<SearchAutocompleteResultProps> = (props) => {
  const { hit: { autocomplete_text: [autocompleteText] } } = props;

  const classNames = c('SearchAutocompleteResult');

  return (
    <div className={classNames}>
      <i className="icon icon-search" />
      <span className="asH4 m-0">{autocompleteText}</span>
    </div>
  );
};

export default SearchAutocompleteResult;
